// Promo-modals

( function($, waTheme) {

    var PromoModal = (function ($) {

        PromoModal = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options['$wrapper'];

            // VARS
            that.options = that.$wrapper.data("modal");

            // DYNAMIC VARS

            // EVENTS
            that.init();
        };

        PromoModal.prototype.init = function () {
            var that = this;

            if (parseInt(that.options["timer"], 10) && $.cookie(that.options["cookie-name"]) === undefined) {
                setTimeout(function () {

                    // show
                    that.$wrapper.modal("show");

                    // set cookie
                    var date = new Date();
                    date.setTime(date.getTime() + (that.options["cookie-time"] * 60 * 60 * 1000));
                    $.cookie(that.options["cookie-name"], "true", {expires: date, path: "/"});

                }, that.options["timer"] * 1000);
            }
        }

        return PromoModal;

    })($);

    waTheme.init.site.PromoModal = PromoModal;

    var $promoModal = $(".b-promo-modal");
    if ($promoModal.length) {
        new window.waTheme.init.site.PromoModal({
            $wrapper: $promoModal
        });
    }

})(jQuery, window.waTheme);